<template>
  <v-text-field
    :id="inputId"
    :label="inputLabel"
    v-model="valorInterno"
    :disabled="campoDesabilitado"
    :required="campoObrigatorio"
    :rules="[rules.requiredTime]"
    :counter="maxCaracteres"
    :maxlength="maxCaracteres"
    @input="emiteValorAlterado"
  ></v-text-field>
</template>
<script>
import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoTexto',
  props: {
    value: {
      type: [String],
    },
  },
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  computed: {
    maxCaracteres() {
      const { desAtributos } = this.metadados;
      if (!desAtributos) return null;
      return desAtributos.max;
    },
  },
  data() {
    return {
      valorInterno: null,
      rules: {
        requiredTime: () => {
          if (!this.campoObrigatorio) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const val = this.valorInterno ? this.valorInterno.trim() : null;
          return !!(val) || msg;
        },
      },
    };
  },
};
</script>
